import {BaseIntDTO} from "../_baseIntDTO.interface";

export interface FaultStatusDTO extends BaseIntDTO {
  name?: string;
  description?: string;
}
